// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__24JSG","filesListContainer":"PosDisputesFiles_filesListContainer__2QfNP","filesButton":"PosDisputesFiles_filesButton__3WC3R"};